import { Endpoint } from "./config";
import { EndpointType } from "./types";
import { authEndpoints } from "./modules/auth";
import { userEndpoints } from "./modules/user";
import { chatEndpoints } from "./modules/chat";
import { documentEndpoints } from "./modules/document";
import { companyEndpoints } from "./modules/company";
import { masterEndpoints } from "./modules/master";
import { reportEndpoints } from "./modules/report";
import { cmsEndpoints } from "./modules/cms";
import { permissionEndpoints } from "./modules/permission";
import { roleEndpoints } from "./modules/role";
import { todoEndpoints } from "./modules/todo";
import { notificationEndpoints } from "./modules/notification";
import { signEndpoints } from "./modules/sign";
import { bankEndpoints } from "./modules/bank";
export * from "./config";
export * from "./types";
export * from "./modules/auth";
export * from "./modules/user";
export * from "./modules/chat";
export * from "./modules/document";
export * from "./modules/company";
export * from "./modules/master";
export * from "./modules/report";
export * from "./modules/cms";
export * from "./modules/permission";
export * from "./modules/role";
export * from "./modules/todo";
export * from "./modules/notification";
export * from "./modules/sign";
export * from "./modules/bank";
export const endpoints: Record<EndpointType, Endpoint> = {
  ...authEndpoints,
  ...userEndpoints,
  ...chatEndpoints,
  ...documentEndpoints,
  ...companyEndpoints,
  ...masterEndpoints,
  ...reportEndpoints,
  ...cmsEndpoints,
  ...permissionEndpoints,
  ...roleEndpoints,
  ...todoEndpoints,
  ...notificationEndpoints,
  ...signEndpoints,
  ...bankEndpoints,
};
